<template>
  <div class="content-wrapper" v-if="modalBehavior.showModalProcedureSearch" ref="container">
    <div class="content">
      <table class="w-100">
        <tbody>
        <tr>
          <th class="text text-center title" colspan="3">Procedure</th>
        </tr>
        <tr>
          <td class="text text-center subtitle" colspan="3">What is the kind of procedure?</td>
        </tr>
        <tr>
          <td><label>NOTE: Search and select a procedure, or pick one from recent choices below.</label></td>
        </tr>
        <tr>
          <td><label for="desc">Ex. EKG, X-ray, ...</label></td>
        </tr>
        <tr>
          <td class="w-50"><input id="desc" type="text" name="desc" v-model="procedureDesc" @keypress="pressToProceed" class="w-100"></td>
          <td><button type="button" class="btn btn--success" @click="handleSearchProcedure">Search</button></td>
        </tr>
        </tbody>
      </table>
      <!-- search results -->
      <ul class="list">
        <li class="list__item" v-if="!paginateData || paginateData.length < 1">
          <small style="color:#ff4444">No item to select from</small>
        </li>
        <li v-for="(procedure, index) in paginateData" :key="index" class="list__item">
          <a class="list__link" :class="{selected:procedure.ccd===procedureSelected}"
                  @click="selectProcedure(procedure.ccd)">
            {{index+1}}. {{ procedure.desc }}
          </a>
        </li>
      </ul>
    </div>

    <!-- pagination-->
    <div v-if="procedureSearchResults.length>0">
      <button :disabled="pageNumber === 0"
              @click="prevPage"
              class="btn btn-prev">
        Previous
      </button>

      <input type="text" v-model="currPageNumber" id="currentPageNumber" style="width: 30px"/>
      <label for="currentPageNumber">/{{pageCount}} <button @click="toPage(currPageNumber-1)" class="btn ml-2">Go</button></label>

      <button :disabled="pageNumber >= pageCount -1"
              @click="nextPage" class="btn btn-next">
        Next
      </button>
    </div>
      <select class='recents form-select' size='4'>
        <option selected>Recent choices...</option>
        <option v-for="recent in recents" :key="recent" :value="recent" @click="selectProcedure2(recent)">
        {{  describe(recent)}}
        </option>
      </select>
    <!-- footer -->
    <div class="modal-footer">
      <button type="button" class="btn btn-danger btn--cancel"
              @click="slideModalTo('main')">Go back</button>
      <button type="submit" class="btn btn--success" @click="handleSaveExtraction">Save as report</button>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {searchNpi, searchProcedure} from '@/api/pdfApi';
import { h } from 'vue';

  export default {
    name: "SaveModalCategorySearch",
    props: {
      modalBehavior: Object,
    },
    data() {
      return {
        procedureDesc: '',
        procedureSelected: '',
        procedureSearchResults: [],
        pageNumber: 0,
        size: 5,
        currPageNumber: 1,
      }
    },
    computed: {
      pageCount: function () {
        let l = this.procedureSearchResults.length;
        return Math.ceil(l / this.size);
      },
      paginateData: function () {
        let start = this.pageNumber * this.size, end = start + this.size;
        return this.procedureSearchResults.slice(start, end);
      },
      ...mapGetters('login', {
        allData: 'getAllData'
      }),
      /**
       * Recent procedures for this patient.
       * Provider step lists known NPIs from allData.npis (not recent.report.npi).
       * Mirror that here: collect procedure CCDs already used on saved reports,
       * then fall back to recent.report.ccd from getAllData.
       */
      recents() {
        const seen = new Set();
        const out = [];
        const pushCcd = (ccd) => {
          if (ccd == null || ccd === '') return;
          const key = String(ccd);
          if (seen.has(key)) return;
          // Only show entries we can label (avoids blank / broken options).
          if (!this.describe(ccd)) return;
          seen.add(key);
          out.push(ccd);
        };

        const reports = this.allData?.reports;
        if (Array.isArray(reports)) {
          for (const report of reports) {
            pushCcd(report?.procCcd);
          }
        }

        const fromRecent = this.allData?.recent?.report?.ccd;
        if (Array.isArray(fromRecent)) {
          for (const ccd of fromRecent) {
            pushCcd(ccd);
          }
        }

        return out;
      }
    },
    methods: {
      slideModalTo(modal) {
        this.$emit('slideModalTo', modal);
      },
      describe(ccd) {
        return this.allData?.ccds?.[ccd]?.desc || '';
      },
      handleSaveExtraction() {
        this.$emit('handleSaveExtraction', this.procedureSelected);
      },
      handleSearchProcedure() {
        if (this.procedureDesc) {
          this.loader =  this.$loading.show({
            container: this.$refs.categoryContainer
          }, {
            after: () => h('div',{},`Searching "${this.procedureDesc}"...`)
          });
          searchProcedure(this.procedureDesc)
              .then((procedures) => {
                this.procedureSearchResults = _.orderBy(procedures, 'desc');
                this.currPageNumber = 1;
              })
              .catch((err) => {
                console.error(err);
              }).finally(() => {
                this.loader.hide();
                this.loader = null;
              });
        }
      },
      selectProcedure(ccd) {
        this.procedureSelected = ccd;
        this.$emit('selectProcedure', ccd);
      },
      selectProcedure2(ccd) {
        this.procedureSelected = ccd;
        this.$emit('selectProcedure', ccd);
        this.handleSaveExtraction();
      },
      pressToProceed(event) {
        if (event.keyCode === 13) {
          this.handleSearchProcedure();
        }
      },

      // pagination
      nextPage() {
        this.pageNumber++;
        this.currPageNumber = this.pageNumber+1;
      },
      prevPage() {
        this.pageNumber--;
        this.currPageNumber = this.pageNumber+1;
      },
      toPage(pageNumber) {
        this.pageNumber = pageNumber;
      },

    }

  }
</script>

<style scoped lang="scss">
  @import "../../../../stylesheets/modules/extraction-save-modal";
  .recents option:hover {
    background-color: rgb(192,192,192);
  }
  .list {
    padding: 0;
  }
  .list__item {
    list-style-type: none;
    /*padding-bottom: 5px;*/
  }
  /* pagination */
  .btn-number {
    border: none;
    background-color: transparent;
    cursor: pointer;
    font-size: 0.75em;
  }
  .btn-prev, .btn-next {
    background-color: transparent;

    &:hover {
      background-color: transparent;
    }
  }
  
  .list__link {
    font-size: 0.85em;
    color: #0060ff !important;
    cursor: pointer;
    padding: 5px;

    &:hover {
      // text-decoration: underline !important;
      background: #0060ff;
      color: white !important;
    }
  }
  .selected {
    background: #0060ff;
    color: white !important;
    border-radius: 3px;
  }
</style>